<template>
  <div>
    <div class="form-inline">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div>
          <el-form-item label="版本类型">
            <el-select
              size="small"
              v-model="formInline.versionType"
              placeholder="请选择版本类型"
            >
              <el-option
                v-for="item in versionTypes"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="版本号">
            <el-input
              size="small"
              v-model="formInline.version"
              placeholder="请输入版本号"
            ></el-input>
          </el-form-item>
          <el-form-item label="固件分区">
            <el-select
              size="small"
              v-model="formInline.firmArea"
              placeholder="请选择固件分区"
            >
              <el-option label="A" value="A"></el-option>
              <el-option label="B" value="B"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目">
            <el-select
              size="small"
              filterable
              v-model="formInline.projectId"
              v-el-select-loadmore="loadMore"
              placeholder="请选择所属项目"
            >
              <el-option
                v-for="item in project.list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item>
            <el-button type="success" plain @click="onQuery">查询</el-button>
            <el-button plain @click="onReset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="cards-container">
      <el-card
        :body-style="{ padding: '0px' }"
        class="card-item"
        v-for="device in deviceList"
        :key="device.sn"
        shadow="hover"
      >
        <!-- <div class="image-container">
          <el-image
            :src="require('@/assets/battery.png')"
            :fit="image_fit"
            class="product-image"
          ></el-image>
        </div> -->
        <div class="progress-container">
          <el-progress
            type="circle"
            :percentage="device.progress"
            :width="100"
            :status="
              device.status === 20
                ? 'success'
                : (device.status >= 21 && device.status <= 27)
                ? 'exception'
                : undefined
            "
          ></el-progress>
        </div>
        <div class="card-content">
          <div class="device-info">
            <div class="info-item">
              <i class="el-icon-cpu"></i>
              <span class="info-label">SN号：</span>
              <span class="info-value">{{ device.sn }}</span>
            </div>
            <!-- Other info items -->
            <div class="info-item">
              <i class="el-icon-eleme"></i>
              <span class="info-label">固件名称：</span>
              <span class="info-value">{{ device.fileName }}</span>
            </div>
            <div class="info-item">
              <i class="el-icon-document"></i>
              <span class="info-label">最新版本：</span>
              <span class="info-value">{{ device.version }}</span>
            </div>
            <div class="info-item">
              <i class="el-icon-position"></i>
              <span class="info-label">固件分区：</span>
              <span class="info-value">{{ device.area }}</span>
            </div>
            <div class="info-item">
              <i class="el-icon-s-claim"></i>
              <span class="info-label">版本类型：</span>
              <span class="info-value">{{ device.versionType }}</span>
            </div>
          </div>

          <div class="btn-upgrade">
            <el-button
              v-if="hasPermission('ota.upgrade.upgrade')"
              :type="getUpgradeBtnType(device.status)"
              :plain="true"
              class="upgrade-btn"
              :disabled="isUpgradeDisabled(device)"
              @click="onUpgrade(device)"
            >
              {{ getUpgradeBtnText(device.status) }}
              <i :class="getUpgradeBtnIcon(device.status)"></i>
            </el-button>
            <el-button
              v-if="hasPermission('ota.upgrade.cancel') && isInProgress(device.status) && device.status !== 16"
              type="warning"
              :plain="true"
              class="upgrade-btn"
              @click="onCancel(device)"
            >
              取消升级 <i class="el-icon-close el-icon--right"></i>
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="formInline.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="formInline.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "Upgrade",
  data() {
    return {
      //   image_fit: "fill",
      deviceList: [],
      upgradeDevices: [],
      versionTypes: [],
      project: {
        total: 0,
        list: [],
        pageNo: 1
      },
      tableData: [],
      formInline: {
        versionType: "",
        version: "",
        firmArea: "",
        projectId: "",
        pageNo: 1,
        pageSize: 5,
        total: 0
      }
    };
  },
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const scrollWrap = el.querySelector(".el-select-dropdown__wrap");
        scrollWrap.addEventListener("scroll", () => {
          const { scrollTop, scrollHeight, clientHeight } = scrollWrap;
          if (scrollHeight - scrollTop == clientHeight) {
            binding.value(); // 触发加载更多
          }
        });
      }
    }
  },
  methods: {
    getVersionType() {
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/versionType",
        method: "GET",
        callback: response => {
          this.versionTypes = response;
        }
      });
    },
    getProjects(pageNo) {
      const data = {
        pageNo: pageNo,
        pageSize: 10
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/dcProject/page",
        data: data,
        method: "GET",
        callback: response => {
          const filteredList = response.list.map(item => ({
            value: item.id,
            label: item.name
          }));

          this.project.list = [...this.project.list, ...filteredList];
          this.project.count = response.count;
        }
      });
    },
    loadMore() {
      if (this.project.list.length < this.project.count) {
        this.project.pageNo++;
        this.getProjects(this.project.pageNo);
        console.log("loadMore!");
      }
    },
    onQuery() {
      this.getDeviceList();
    },
    onReset() {
      this.formInline.versionType = "";
      this.formInline.version = "";
      this.formInline.firmArea = "";
      this.formInline.projectId = "";
    },
    getDeviceList() {
      const data = {
        versionType: this.formInline.versionType,
        version: this.formInline.version,
        firmArea: this.formInline.firmArea,
        projectId: this.formInline.projectId,
        pageNo: this.formInline.pageNo,
        pageSize: this.formInline.pageSize
      };
      this.$store.dispatch("firmware/handleRequest", {
        url: "/battery/ota/upgrade/device",
        data: data,
        method: "GET",
        callback: response => {
          this.deviceList = response.list;
          this.formInline.total = response.count;
          this.formInline.pageNo = response.pageNo;
          this.formInline.pageSize = response.pageSize;
        }
      });
    },

    // 按钮类型（颜色）
    getUpgradeBtnType(status) {
      if (status === 0) return "primary";        // 可升级
      if (status >= 10 && status < 20) return "info"; // 进行中
      if (status === 20) return "success";        // 成功
      return "danger";                            // 终态失败/取消/中断
    },
    // 按钮文字
    getUpgradeBtnText(status) {
      const map = {
        0: "立即升级",
        10: "已通知",
        11: "已确认",
        12: "元数据已发",
        13: "传输中",
        14: "已校验",
        15: "待执行",
        16: "取消中",
        20: "升级成功",
        21: "升级失败",
        22: "执行后失败",
        23: "已回滚",
        24: "已取消",
        25: "取消过晚",
        26: "已中断",
        27: "确认超时"
      };
      return map[status] || "立即升级";
    },
    // 按钮图标
    getUpgradeBtnIcon(status) {
      if (status >= 10 && status < 20) return "el-icon-loading el-icon--right";
      if (status === 20) return "el-icon-check el-icon--right";
      if (status >= 21) return "el-icon-close el-icon--right";
      return "el-icon-s-promotion el-icon--right";
    },
    // 是否进行中
    isInProgress(status) {
      return status >= 10 && status < 20;
    },
    // 禁用逻辑：进行中(10-16)或成功(20)禁用；未开始(0)或终态失败(21-27)可重新下发
    isUpgradeDisabled(device) {
      return (
        this.isInProgress(device.status) ||
        device.status === 20 ||
        this.upgradeDevices.some(
          upgradingDevice => upgradingDevice.sn === device.sn
        )
      );
    },
    onUpgrade(device) {
      console.log("onUpgrade!", device);
      this.upgradeDevices.push({
        sn: device.sn,
        upgrading: true
      });

      this.$confirm("升级设备时不能对设备进行操作，确认要升级？", "确认升级", {
        confirmButtonText: "确认升级",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("firmware/handleRequest", {
            url: "/battery/ota/upgrade/device/" + device.upgradeId,
            method: "POST",
            callback: response => {
              this.$message.success("升级请求发送成功");
              this.getDeviceList();
            },
            complete: () => {
              // 无论成功失败都会执行
              this.upgradeDevices = this.upgradeDevices.filter(
                item => item.sn !== device.sn
              );
              console.log("complete!");
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消升级");
          this.upgradeDevices = this.upgradeDevices.filter(
            item => item.sn !== device.sn
          );
        });
    },
    onCancel(device) {
      console.log("onCancel!", device);
      this.$confirm("确认取消该设备的升级任务？", "取消升级", {
        confirmButtonText: "确认取消",
        cancelButtonText: "返回",
        type: "warning"
      })
        .then(() => {
          this.$store.dispatch("firmware/handleRequest", {
            url: "/battery/ota/upgrade/cancel/" + device.upgradeId,
            method: "POST",
            callback: () => {
              this.$message.success("取消指令已下发");
              this.getDeviceList();
            }
          });
        })
        .catch(() => {});
    },
    handleCurrentChange(pageNo) {
      this.formInline.pageNo = pageNo;
      this.getDeviceList(); // 刷新列表
    },

    handleSizeChange(pageSize) {
      this.formInline.pageSize = pageSize;
      this.getDeviceList(); // 刷新列表
    },
    hasPermission(permission) {
      if (!permission) {
        return true;
      }
      let flag = false;
      const menus = this.$store.state.login.menu;
      for (let i = 0; i < menus.length; i++) {
        const menu = menus[i];
        if (menu == permission) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  },
  beforeMount() {
    // console.log("beforeMount!");
    this.getVersionType();
    this.getProjects(this.project.pageNo);
    this.getDeviceList();
  } //生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
.form-inline {
  border-bottom: 1px solid #dcdfe6;
}
.demo-form-inline {
  display: flex;
  justify-content: space-between;
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
.btn-group {
  margin: 10px;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  /deep/ .el-pagination {
    padding: 0;
  }
}
.cards-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  gap: 10px;
}
// Color variables
@primary-color: #409eff;
@success-color: #67c23a;
@text-color: #303133;
@text-color-secondary: #909399;
@background-gradient: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
@shadow-color: rgba(0, 0, 0, 0.1);
@success-shadow: rgba(67, 160, 71, 0.3);

// Card styles
.card-item {
  width: 220px;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
  border: none;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px @shadow-color;
  }
  .progress-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
  }
}

// Image container
.image-container {
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: @background-gradient;
  .product-image {
    filter: drop-shadow(0 4px 8px @shadow-color);
  }
}

// Content area
.card-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: calc(100% - 120px);
}

// Device information
.device-info {
  flex: 1;

  .info-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 11px;

    i {
      margin-right: 8px;
      color: @primary-color;
      font-size: 16px;
    }

    .info-label {
      color: @text-color-secondary;
      margin-right: 4px;
      font-weight: 500;
      white-space: nowrap; // 防止标签换行
    }

    .info-value {
      color: @text-color;
      font-weight: 600;
      word-break: break-word; // 长文本自动换行
      flex: 1; // 占据剩余空间
    }
  }
}

// Upgrade button
.btn-upgrade {
  margin-top: auto;
  text-align: center;
  //   padding-top: 12px;

  //   .upgrade-btn {
  //     width: 100%;
  //     border-radius: 20px;
  //     font-weight: bold;
  //     letter-spacing: 1px;
  //     transition: all 0.3s;

  //     &:hover {
  //       transform: translateY(-2px);
  //       box-shadow: 0 4px 8px @success-shadow;
  //     }
  //   }
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/otaManager/upgrade.vue